document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  if (body.classList.contains("single-post")) {
    const widgets = document.querySelectorAll(".widget");

    if (widgets.length > 0) {
      const styledElements = document.querySelectorAll("[style]");
      styledElements.forEach(el => el.removeAttribute("style"));

      widgets.forEach(widget => {
        const coloredElements = widget.querySelectorAll("[color]");
        coloredElements.forEach(el => el.removeAttribute("color"));
      });
    }
  }
});
